import React, { useState, useEffect } from "react";
import "./Navbar.css";

function Navbar() {
  const [activeSection, setActiveSection] = useState("hero");

  useEffect(() => {
    const sections = document.querySelectorAll("section");
  // Lower threshold and add rootMargin for more sensitive section detection
  const options = { threshold: 0.08, rootMargin: '-60px 0px -60% 0px' };

    const observer = new IntersectionObserver((entries) => {
      // Find the entry closest to the top that is intersecting
      let mostVisible = null;
      let maxRatio = 0;
      entries.forEach((entry) => {
        if (entry.isIntersecting && entry.intersectionRatio > maxRatio) {
          mostVisible = entry;
          maxRatio = entry.intersectionRatio;
        }
      });
      if (mostVisible) {
        setActiveSection(mostVisible.target.id);
      }
    }, options);

    sections.forEach((section) => observer.observe(section));

    return () => {
      sections.forEach((section) => observer.unobserve(section));
    };
  }, []);

  // Helper to handle link clicks and set active section immediately
  const handleNavClick = (section) => {
    setActiveSection(section);
  };

  return (
    <nav className="navbar">
      <div className="navbar-logo">
        <img src="/Images/logo.png" alt="Company Logo" />
      </div>
      <ul className="navbar-links">
        <li>
          <a
            href="#hero"
            className={activeSection === "hero" ? "active" : ""}
            onClick={() => handleNavClick("hero")}
          >
            HOME
          </a>
        </li>

        {/* ✅ Dropdown for Projects */}
        <li className="dropdown">
          <a
            href="#all-projects"
            className={
              activeSection === "all-projects" ||
              activeSection === "ongoing-projects" ||
              activeSection === "project-videos"
                ? "active"
                : ""
            }
            onClick={() => handleNavClick("all-projects")}
          >
            PROJECTS ▾
          </a>
          <ul className="dropdown-menu">
            <li>
              <a
                href="#all-projects"
                className={activeSection === "all-projects" ? "active" : ""}
                onClick={() => handleNavClick("all-projects")}
              >
                All Projects
              </a>
            </li>
            <li>
              <a
                href="#ongoing-projects"
                className={activeSection === "ongoing-projects" ? "active" : ""}
                onClick={() => handleNavClick("ongoing-projects")}
              >
                Ongoing Projects
              </a>
            </li>
            <li>
              <a
                href="#project-videos"
                className={activeSection === "project-videos" ? "active" : ""}
                onClick={() => handleNavClick("project-videos")}
              >
                Project Videos
              </a>
            </li>
          </ul>
        </li>

        <li>
          <a
            href="#about"
            className={activeSection === "about" ? "active" : ""}
            onClick={() => handleNavClick("about")}
          >
            ABOUT
          </a>
        </li>
        <li>
          <a
            href="#contact"
            className={activeSection === "contact" ? "active" : ""}
            onClick={() => handleNavClick("contact")}
          >
            CONTACT
          </a>
        </li>
        <li>
          <a
            href="#achievements"
            className={activeSection === "achievements" ? "active" : ""}
            onClick={() => handleNavClick("achievements")}
          >
            ACHIEVEMENTS
          </a>
        </li>
      </ul>
    </nav>
  );
}

export default Navbar;
